import { isDefined, isNotDefined } from '@sgme/fp';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import {
  useForwardAccumulatorSelector,
  useForwardAccumulatorTileId,
} from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { getForwardAccumulatorQuote, selectForwardAccumulatorEspSpot } from '@/store/forwardAccumulator/selectors.ts';
import { useAppSelector } from '@/store/hooks.ts';

export function SpotField() {
  const tileId = useForwardAccumulatorTileId();
  const espSpot = useAppSelector((state) => selectForwardAccumulatorEspSpot(state, tileId));
  const rfsSpot = useForwardAccumulatorSelector((product) => {
    const quote = getForwardAccumulatorQuote(product);
    if (isNotDefined(quote)) {
      return undefined;
    }
    return { bid: quote.spot.bid, ask: quote.spot.ask };
  });

  return (
    <div className="form-group form-group-sm d-flex my-1 no-gutters">
      <div className="pe-1 col-form-label col-form-label-sm col-4 text-nowrap text-end">
        <FormattedMessage id="forwardAccumulator.fields.spot" />
      </div>
      <div className="d-flex flex-column px-1 col-7 justify-content-center fs-6" data-e2e="midPrice-spot">
        {isDefined(espSpot) && isNotDefined(rfsSpot) && <FormattedNumber value={espSpot} maximumFractionDigits={10} />}

        {isDefined(rfsSpot) && (
          <div data-e2e="rfs-spot" className="monospace-numbers">
            <FormattedNumber value={rfsSpot.bid} maximumFractionDigits={10} />
            <span> / </span>
            <FormattedNumber value={rfsSpot.ask} maximumFractionDigits={10} />
          </div>
        )}

        {isNotDefined(rfsSpot) && isNotDefined(espSpot) && <span className="text-secondary">-</span>}
      </div>
    </div>
  );
}
